
<Popup
  v-model:visible="visible"
  class="toast-wrapper"
  overlay-class="toast-wrapper"
  :visible.sync="visible"
  :close-on-click-overlay="false"
  :z-index="zIndex"
  @clickOverlay="onClickOverlay"
>
  <div
    :class="classes(n(), n('$--box'), n(`${isTextToast ? 'text' : 'icon'}`))"
    :style="toastStyle"
  >
    <!-- 纯文本类型 -->
    <div
      v-if="isTextToast"
      :class="classes(n('content-text'))"
    >
      <span v-html="message" />
    </div>
    <!-- 带Icon类型 -->
    <div
      v-else
      :class="classes(n('content-icon'))"
    >
      <!-- 图标 -->
      <component
        :is="toastIconComp"
        :class="classes({ [n('content-icon_loading')]: isLoadingToast })"
        width="80"
        height="80"
        color="#ffffff"
      />
      <!-- 文本 -->
      <div
        :class="classes(n('content-icon_text_common'), n(`${showDotLine ? 'content-icon_text_dot' : 'content-icon_text'}`))"
        v-html="message"
      />
      <!-- 底部加载Loading -->
      <div
        v-if="showDotLine"
        :class="classes(n('content-icon_dot'))"
      >
        <div :class="classes(n('content-icon_dot_item'))" />
        <div :class="classes(n('content-icon_dot_item'))" />
        <div :class="classes(n('content-icon_dot_item'))" />
      </div>
    </div>
  </div>
</Popup>
